var {AmpersandModel} = require('catalog/libs');

var ProductBaseModel = AmpersandModel.extend({
    props: {
        oid: 'string',
        prodname: 'string',
        produrl: 'string',
        prodnameurl: 'string',
        'new': 'boolean',
        updated: 'boolean',
        compare: 'boolean',
        'skin': {
            'type': 'string',
            'default': 'default',
            'values': ['default', 'compact']
        },
        specs: 'array',
        images: 'array',
        price: 'string'
    },
    derived: {
        hasPrice: {
            deps: ['price'],
            fn: function () {
                var hasPrice = true;
                if (Math.round(parseInt(this.price)) !== 0) {
                    hasPrice = false;
                }
                return hasPrice;
            }
        }
    }
});

module.exports = {
    ProductBaseModel: ProductBaseModel
};
